import logo from '../../assets/CatwikiLogo.svg'
import catWhite from '../../assets/CatWhite.svg'

import image1 from '../../assets/image 1.png'
import image2 from '../../assets/image 2.png'
import image3 from '../../assets/image 3.png'

export default {
  logo,
  catWhite,
  image1,
  image2,
  image3,
}